<template>
  <div class="clue-detail">
    <van-nav-bar
      fixed
      title="线索详情"
      left-arrow
      @click-left="$router.go(-1)"
    ></van-nav-bar>
    <div class="title">企业资料</div>
    <div class="companycontent">
      <div class="body-item">
        <div class="item-left">企业名称：</div>
        <div class="item-right">{{ cluedetail.companyName }}</div>
      </div>
      <div class="body-item">
        <div class="item-left">企业法人：</div>
        <div class="item-right">{{ cluedetail.corporate }}</div>
      </div>
      <div class="body-item">
        <div class="item-left">统一社会信用代码：</div>
        <div class="item-right">{{ cluedetail.creditCode }}</div>
      </div>
      <div class="body-item">
        <div class="item-left">法人身份证号：</div>
        <div class="item-right">{{ cluedetail.corporateIDCard }}</div>
      </div>
      <div class="body-item">
        <div class="item-left">注册资金：</div>
        <div class="item-right">{{ cluedetail.registeredCapital }}</div>
      </div>
      <div class="body-item">
        <div class="item-left">注册地址：</div>
        <div class="item-right">{{ cluedetail.companyLocation }}</div>
      </div>
      <div class="body-item">
        <div class="item-left">办公地址：</div>
        <div class="item-right">{{ cluedetail.officeAddress }}</div>
      </div>
      <div class="body-item">
        <div class="item-left">成立时间：</div>
        <div class="item-right">{{ cluedetail.established }}</div>
      </div>
      <div class="body-item">
        <div class="item-left">企业状态：</div>
        <div class="item-right">{{ cluedetail.enterpriseState }}</div>
      </div>
      <div class="body-item">
        <div class="item-left">经营范围：</div>
        <div class="item-right">{{ cluedetail.businessScope }}</div>
      </div>
      <div class="body-item">
        <div class="item-left">信用评级：</div>
        <div class="item-right">{{ cluedetail.creditRating }}</div>
      </div>
    </div>
    <div class="title" style="margin-top: 10px">项目资料</div>
    <div class="companycontent">
      <div class="body-item">
        <div class="item-left">项目名称:</div>
        <div class="item-right">{{ cluedetail.projectName }}</div>
      </div>
      <div class="body-item">
        <div class="item-left">投资主体:</div>
        <div class="item-right">{{ cluedetail.tzzt }}</div>
      </div>
      <div class="body-item">
        <div class="item-left">企业类型:</div>
        <div class="item-right">{{ cluedetail.qylx }}</div>
      </div>
      <div class="body-item">
        <div class="item-left">产业类别:</div>
        <div class="item-right">{{ cluedetail.projectType }}</div>
      </div>

      <div class="body-item">
        <div class="item-left">产业方向:</div>
        <div class="item-right">{{ cluedetail.canye }}</div>
      </div>

      <div class="body-item">
        <div class="item-left">项目类别:</div>
        <div class="item-right">{{ cluedetail.state }}</div>
      </div>

      <div class="body-item">
        <div class="item-left">合同投资:</div>
        <div class="item-right">{{ cluedetail.httz }}</div>
      </div>

      <div class="body-item">
        <div class="item-left">拟转办单位:</div>
        <div class="item-right">{{ cluedetail.lzbdw_name }}</div>
      </div>

      <div class="body-item">
        <div class="item-left">项目选址区域:</div>
        <div class="item-right">{{ cluedetail.luoHuDiZhi }}</div>
      </div>

      <div class="body-item">
        <div class="item-left">企业联系人及电话:</div>
        <div class="item-right">
          {{ cluedetail.contactPerson }} {{ cluedetail.contactNumber }}
        </div>
      </div>
      <div class="body-item">
        <div class="item-left">项目建设内容:</div>
        <div class="item-right">{{ cluedetail.projectDescription }}</div>
      </div>
      <div class="body-item">
        <div class="item-left">项目推进情况:</div>
        <div class="item-right">{{ cluedetail.xmtj }}</div>
      </div>
      <div class="body-item">
        <div class="item-left">备注:</div>
        <div class="item-right">{{ cluedetail.description }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  constants_options_cyfx,
  constants_options_cylb,
  constants_options_project_state,
  constants_options_qylx,
  constants_optisons_jhld,
  constants_options_xmcy,
} from "@/constants";
export default {
  data() {
    return {
      cluedetail: {},
    };
  },
  methods: {
    getdetaildata(id) {
      this.request({
        url: "v1.0/Clues/getCluesDetail",
        method: "GET",
        params: {
          CluesId: id,
        },
      }).then((res) => {
        this.cluedetail = res.data;
        this.cluedetail.projectNature == 1
          ? (this.cluedetail.projectNature = "分公司")
          : this.cluedetail.projectNature == 2
          ? (this.cluedetail.projectNature = "子公司")
          : (this.cluedetail.projectNature = "总部经济");
        if (this.cluedetail.projectType == 100) {
          this.cluedetail.projectType = "第一产业";
        } else if (this.cluedetail.projectType == 101) {
          this.cluedetail.projectType = "第二产业";
        } else if (this.cluedetail.projectType == 102) {
          this.cluedetail.projectType = "第三产业";
        } else if (this.cluedetail.projectType == 103) {
          this.cluedetail.projectType = "一二三产融合";
        }

        if (this.cluedetail.xmtj) {
          this.cluedetail.xmtj =
            JSON.parse(this.cluedetail.xmtj).map(
              (x) => `${x.timestamp} ${x.content}`
            )[0] || "";
        }
        if (this.cluedetail.qylx) {
          this.cluedetail.qylx =
            JSON.parse(this.cluedetail.qylx)?.join(",") || "";
        }
        if (this.cluedetail.projectType) {
          var arr = constants_options_cylb
            .filter((x) => x.value == item.projectType)
            .map((x) => x.text);
          if (arr.length > 0) {
            this.cluedetail.projectType = arr[0];
          }
        }
      });
    },
  },
  computed: {},
  created() {
    console.log(this.$route.query.data, 888);
    this.getdetaildata(this.$route.query.data);
  },
};
</script>

<style lang="scss" scoped>
.clue-detail {
  padding-top: 8vh;
}
.title {
  height: 42px;
  line-height: 42px;
  font-size: 16px;
  padding: 0 16px;
  color: #101010;
  border: 1px solid #ececec;
  margin-bottom: 8px;
  background-color: white;
}
.body-item {
  display: flex;
  padding: 8px 20px 8px 20px;
  background-color: white;
}
.item-left {
  font-size: 13px;
  color: #101010;
  min-width: 70px;
}
.item-right {
  font-size: 13px;
  color: #101010;
}
</style>
